export class ResponseDatosActa{
    payload:DatosEncuestaActa;

    constructor(){
        this.payload = new DatosEncuestaActa();
    }
}

export class DatosEncuestaActa{   
    idActaTutoria:number;
    comentarioJardin:String; 
    idJardinPeriodoTutoria:number;
    pregunta1:number;
    pregunta2:number;
    pregunta3:number;
    pregunta4:number;
    pregunta5:number;
    pregunta6:number;
    constructor(){
        this.idActaTutoria = -1;
        this.comentarioJardin="";
        this.idJardinPeriodoTutoria = -1;
        this.pregunta1 = -1;
        this.pregunta2 = -1;
        this.pregunta3 = -1;
        this.pregunta4 = -1;
        this.pregunta5 = -1;
        this.pregunta6 = -1;
    }
}



export class ResponseDatosActaPM{
    payload:DatosEncuestaActaPM;

    constructor(){
        this.payload = new DatosEncuestaActaPM();
    }
}

export class DatosEncuestaActaPM{   

    idActaTutorPlanMejora:number;
    idJardinPeriodo:number;
    fechaFirmaJardin:Date;
    observacionDirectora:String; 
    numeroActa:number;
    estadoActa:number;
    evaluacion1:number;
    evaluacion2:number;
    evaluacion3:number;
    evaluacion4:number;
    evaluacion5:number;
    evaluacion6:number;
    
    constructor(){
        this.idActaTutorPlanMejora = -1;
        this.idJardinPeriodo = -1;
        this.fechaFirmaJardin = null;
        this.observacionDirectora="";
        this.numeroActa = -1;
        this.estadoActa = -1;
        this.evaluacion1 = -1;
        this.evaluacion2 = -1;
        this.evaluacion3 = -1;
        this.evaluacion4 = -1;
        this.evaluacion5 = -1;
        this.evaluacion6 = -1;
        
    }
}

